var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-payment-approved-4202543",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.271,
    height: 44.392,
    viewBox: "0 0 58.271 44.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12822",
    "data-name": "Path 12822",
    d: "M140.048,230.78H126.39a1.707,1.707,0,0,0-1.707,1.707v6.829a1.707,1.707,0,0,0,1.707,1.707h13.657a1.707,1.707,0,0,0,1.707-1.707v-6.829a1.707,1.707,0,0,0-1.707-1.707Zm-1.707,6.829H128.1v-3.414h10.243Z",
    transform: "translate(-118.993 -213.708)",
    fill: "#5f277e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12823",
    "data-name": "Path 12823",
    d: "M121.212,84.591V68.421a1.707,1.707,0,0,0-1.707-1.707H71.7A1.707,1.707,0,0,0,70,68.421V98.012A1.707,1.707,0,0,0,71.7,99.719h28.4A14.227,14.227,0,1,0,121.212,84.59ZM117.8,70.128v3.414H73.412V70.128ZM73.412,76.957H117.8v6.195a14.227,14.227,0,0,0-17.97,13.154H73.411Zm40.631,30.729a10.825,10.825,0,1,1,7.642-3.17A10.81,10.81,0,0,1,114.043,107.686Z",
    transform: "translate(-69.997 -66.713)",
    fill: "#5f277e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12824",
    "data-name": "Path 12824",
    d: "M442.781,313.259l-4.985,4.615L436,316.2a1.707,1.707,0,0,0-2.322,2.5l2.959,2.745h0a1.707,1.707,0,0,0,2.32,0l6.146-5.691a1.707,1.707,0,0,0-2.322-2.5Z",
    transform: "translate(-395.343 -287.195)",
    fill: "#5f277e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/payment_icon.2c72241e3ceb7eed6b100d3023f25d31.svg";
export { ForwardRef as ReactComponent };